import { Flex, Modal, ModalContent, ModalOverlay, Text } from '@chakra-ui/react'
import { Button as UbiButton } from '@ubirider/pick-component-library'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { IconWithinCircle } from '../../pages/Common/IconWithinCircle'

import deleteImage from '../../assets/cross_white_24.svg'

export const DeleteCardModal = ({ loading, onConfirm, isOpen, onOpen, onClose }) => {
  const { t } = useTranslation()

  const initialRef = useRef(null)
  const finalRef = useRef(null)

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={finalRef}
      isOpen={isOpen}
      onClose={onClose}
      size={{ sm: 'xs', md: 'xl', lg: 'xl', xl: 'xl' }}
      closeOnOverlayClick={false}
      autoFocus={false}
      isCentered
    >
      <ModalOverlay />
      <ModalContent padding={{ sm: '16px 24px', md: '16px 24px', lg: '36px', xl: '36px' }}>
        <Flex direction='column' gap='48px' align='center'>
          <Flex direction='column' gap='16px' align='center'>
            <IconWithinCircle color='danger.600' icon={deleteImage} />
            <Flex direction='column' gap='8px' align='center'>
              <Text
                fontWeight='700'
                fontSize={{ sm: '20px', md: '20px', lg: '24px', xl: '24px' }}
                color='neutral.800'
                align='center'
              >
                Remover cartão bancário
              </Text>
              <Text
                fontWeight='600'
                fontSize={{ sm: '14px', md: '14px', lg: '16px', xl: '16px' }}
                color='neutral.600'
                align='center'
                width={{ md: '380px', lg: '380px', xl: '380px' }}
              >
                Este cartão será removido do seu Portal Acqua Vias.
              </Text>
            </Flex>
          </Flex>

          <Flex gap='16px' display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }}>
            <UbiButton
              onClick={onClose}
              style='outline'
              type='neutralDark'
              label={t('common.cancel')}
              css={{ width: '158px' }}
            />
            <UbiButton
              onClick={onConfirm}
              loading={loading}
              style='solid'
              type='danger'
              label={t('common.delete')}
              css={{ width: '158px' }}
            />
          </Flex>
          <Flex
            gap='16px'
            alignSelf='stretch'
            direction='column'
            display={{ sm: 'flex', md: 'none', lg: 'none', xl: 'none' }}
          >
            <UbiButton
              onClick={onConfirm}
              loading={loading}
              style='solid'
              type='danger'
              label={t('common.delete')}
              css={{ width: '100%' }}
            />
            <UbiButton
              onClick={onClose}
              style='outline'
              type='neutralDark'
              label={t('common.cancel')}
              css={{ width: '100%' }}
            />
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  )
}
